<template>
    <div class="table-responsive">
        <!-- <h5>Reminders</h5> -->
        <loader v-if="isLoading" />
        <b-table-simple v-else hover class="list">
            <b-thead>
                <b-tr>
                    <b-th>Patient:</b-th>
                    <b-th>Item:</b-th>
                    <b-th>Due:</b-th>
                    <b-th>Type:</b-th>
                    <b-th>Remind:</b-th>
                    <b-th>Notes:</b-th>
                    <b-th>Last Sent:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(reminder, i) in reminders" :key="i">
                    <b-td>
                        <input type="hidden" name="id" :value="reminder.id" />
                        <patient-name
                            :use-router="USE_PATIENT_MODULE_VUE"
                            :patient="{
                                name: reminder.patient_name,
                                encoded_id: reminder.encoded_patient_id,
                                ci_url: getPatientCiLink(
                                    reminder.encoded_patient_id
                                ),
                                isactive:
                                    reminder.patient_id == '' ||
                                    reminder.patient_isactive == 1
                                        ? true
                                        : false
                            }"
                        />
                    </b-td>
                    <b-td>
                        <strong
                            class="text-primary cursor-pointer"
                            v-if="reminder.item_name !== ''"
                            @click="goToLink(reminder, conditions, permissions)"
                        >
                            {{ reminder.item_name }}
                        </strong>

                        <span v-else-if="reminder.appointment_id !== ''"
                            >Appointment</span
                        >
                        <span v-else-if="reminder.boarding_id !== ''"
                            >Boarding</span
                        >
                        <span v-else>None selected</span>
                    </b-td>
                    <b-td>
                        {{ _setDateDisplay(reminder.due) }}
                    </b-td>
                    <b-td>
                        {{ reminder.reminder_type_value }}
                    </b-td>
                    <b-td
                        v-html="
                            getClientReminderSendString(reminder, conditions)
                        "
                    >
                    </b-td>
                    <b-td v-html="reminder.reminder_actor_note"> </b-td>
                    <b-td>
                        <span v-if="reminder.sent_date > 0">
                            {{ _setDateDisplay(reminder.sent_date) }}
                        </span>
                        <span v-else>--</span>
                    </b-td>
                    <b-td class="text-right">
                        <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            right
                            v-if="
                                permissions.client_reminder_update ||
                                permissions.client_reminder_complete ||
                                permissions.client_reminder_task ||
                                permissions.client_reminder_delete
                            "
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>

                            <b-dropdown-item
                                href="#"
                                @click="showEditModal(reminder)"
                                v-if="permissions.client_reminder_update"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Reminder
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="#"
                                v-if="permissions.client_reminder_task"
                                @click="showAssignTaskModal(reminder)"
                            >
                                <i class="cus-bell-add"></i>
                                Assign as Task
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="#"
                                v-if="
                                    permissions.schedule_reminder_send_single &&
                                    reminder.reminder_type_id === REMINDER_TYPE.EMAIL ||
                                    (reminder.reminder_type_id === REMINDER_TYPE.SMS &&
                                    checkExtensionsSMSEnabled())
                                "
                                @click="resend(reminder)"
                            >
                                <i class="cus-email-go"></i>
                                Resend Reminder
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="#"
                                v-if="permissions.client_reminder_complete"
                                @click="completeReminder(reminder)"
                            >
                                <i class="cus-accept"></i>
                                Complete Reminder
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="#"
                                v-if="permissions.client_reminder_delete"
                                @click="confirmDelete(reminder)"
                            >
                                <i class="cus-delete"></i>
                                Delete Reminder
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="reminders.length == 0 && !isLoading">
                    <b-td colspan="8"><i>No records available</i></b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getList"
        />

        <modal-delete
            modal-id="confirm-delete-reminder"
            :reminder="selectedReminder"
            @reload="getList()"
        />

        <modal-edit
            ref="modalEditReminder"
            :reminder="selectedReminder"
            :client-id="clientId"
            @reload="getList()"
        />

        <modal-assign-task
            ref="modalAssignTask"
            :reminder="selectedReminder"
            :client-name="getClientName()"
            @reload="getList()"
        />

        <modal-record ref="modalRecord" />
    </div>
</template>
<script>
import Reminders from "@/services/client-reminders";
import modalRecord from "@/module/commons/record/create-update";
import Loader from "@/components/elements/loader-list";
import Records from "@/services/records";
import _ from "lodash";
import EXTENSIONS from "@/constants/extensions";

export default {
    components: {
        Loader,
        modalRecord,
        ModalDelete: () =>
            import("@/components/client-reminders/reminder-delete-modal"),
        ModalEdit: () =>
            import("@/components/client-reminders/reminder-save-modal"),
        ModalAssignTask: () =>
            import("@/components/client-reminders/reminder-to-task"),
        PatientName: () => import("@/components/commons/patient-name")
    },
    data() {
        return {
            reminders: [],
            isLoading: false,
            selectedReminder: {},
            permissions: [],
            conditions: [],
            currentBusinessId: null,
            meta: null
        };
    },
    props: {
        client: {
            type: Object,
            default: null
        }
    },
    computed: {
        clientId() {
            return this.$store.state.client.client_id;
        },
        clientDetails() {
            return this.$store.getters["client/clientDetails"];
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        checkExtensionsSMSEnabled() {
            return this.client?.mobile && (
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_SMS) ||
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_2_WAY_MESSAGING)
            );
        },
        getList(page) {
            this.isLoading = true;
            let params = {
                id: this.clientId,
                page: page ? page : 1,
                perPage: this.PER_PAGE,
                module: "client"
            };

            Reminders.getReminders(params)
                .then(response => {
                    if (response.message.code == 200) {
                        this.reminders = response.reminders;
                        this.meta = response.meta;
                        this.permissions = response.permissions;
                        this.conditions = response.conditions;
                        this.currentBusinessId = response.current_business_id;
                        this.isLoading = false;
                    }

                    this.isLoading = false;
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to get reminder list",
                        "danger"
                    );
                    console.error(error);
                });
        },
        showError() {},
        confirmDelete(reminder) {
            this.selectedReminder = reminder;
            this.$bvModal.show("confirm-delete-reminder");
        },
        completeReminder(reminder) {
            let params = {
                reminder_id: reminder.reminder_id,
                reminder_actor_id: reminder.reminder_actor_id
            };

            Reminders.completeReminder(params)
                .then(response => {
                    if (response.state === 0) {
                        this._message(response.message);
                        this.getList(1);
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to complete reminder",
                        "danger"
                    );
                    console.error(error);
                });
        },
        resend(reminder) {
            if (reminder.reminder_type_id === this.REMINDER_TYPE.EMAIL) {
                let params = {
                    reminder_id: reminder.reminder_id,
                    reminder_actor_id: reminder.reminder_actor_id,
                    timestamp:
                        this._now().toFormat(this._dateFormat) +
                        " " +
                        this._now().toFormat("h:mm a")
                };

                Reminders.sendReminder(params)
                    .then(response => {
                        if (response.state === 0) {
                            this._message(response.message);
                            this.getList(1);
                        } else {
                            this._message(response.message, "danger");
                        }
                    })
                    .catch(error => {
                        this._message(
                            "Error : Unable to complete reminder",
                            "danger"
                        );
                        console.error(error);
                    });
            } else if (reminder.reminder_type_id === this.REMINDER_TYPE.SMS) {
                let params = {
                    reminder_id: reminder.reminder_id,
                    reminder_actor_id: reminder.reminder_actor_id,
                    reminder_type: reminder.reminder_type_id
                };

                Reminders.sendBulkReminder(params)
                    .then(({ response: { message } }) => {
                        const { sms, code } = message;
                        
                        if (code === 200) {
                            if (sms.success > 0) {
                                this._message(`Reminder sent`);
                            } else if (sms.failed > 0) {
                                this._message(`Failed to send reminder`, "danger");
                            }
                            this.getList(1);
                        } else {
                            this._message(`Failed to send reminder`, "danger");
                        }
                    })
                    .catch(error => {
                        this._message(
                            "Error : Unable to complete reminder",
                            "danger"
                        );
                        console.error(error);
                    });
            }
        },
        showEditModal(reminder) {
            this.selectedReminder = reminder;

            this.$store.dispatch("checkBillingLock", {
                date: reminder.due,
                onProceed: () => this.$refs.modalEditReminder.open(),
                onError: message => this._message(message, "danger")
            });
        },
        showAssignTaskModal(reminder) {
            this.selectedReminder = reminder;
            this.$refs.modalAssignTask.open();
        },
        goToLink(reminder, conditions, permissions) {
            this.selectedReminder = reminder;

            if (
                reminder.record_id &&
                reminder.business_id == this.currentBusinessId
            ) {
                if (reminder.record_type === conditions.RECORD.TYPE_LAB) {
                    if (permissions.schedule_reminder_update) {
                        if (this.valid_uuid(reminder.record_soap_id)) {
                            window.location.href =
                                process.env.CI_APPS +
                                "soap/lab/view/" +
                                reminder.record_soap_id +
                                "/" +
                                reminder.record_id;
                        } else {
                            window.location.href =
                                process.env.CI_APPS +
                                "patient/lab/view/" +
                                reminder.patient_id +
                                "/" +
                                reminder.record_id;
                        }
                    }
                } else {
                    if (permissions.schedule_reminder_update) {
                        let date = null;
                        if (reminder.record_id != "") {
                            if (
                                reminder.invoice_id !== "" &&
                                reminder.invoice_start < reminder.record_date
                            ) {
                                date = reminder.invoice_start;
                            } else {
                                date = reminder.record_date;
                            }
                        }

                        this.$store.dispatch("checkBillingLock", {
                            date,
                            onProceed: () => this.openRecordDialog(reminder),
                            onError: message => this._message(message, "danger")
                        });
                    }
                }
            } else {
                this.$refs.modalEditReminder.open();
            }
        },
        getClientReminderSendString(reminder, conditions) {
            var reminder_send_string = "";
            if (
                reminder.reminder_type_id == conditions.REMINDER.OPTION_MAIL ||
                reminder.reminder_type_id == conditions.REMINDER.OPTION_PHONE ||
                reminder.reminder_type_id ==
                    conditions.REMINDER.OPTION_NO_REMINDER
            ) {
                reminder_send_string = "Day due";
            } else if (
                reminder.reminder_type_id == conditions.REMINDER.OPTION_EMAIL ||
                reminder.reminder_type_id == conditions.REMINDER.OPTION_SMS
            ) {
                var reminder_period = reminder.time_period_value;
                if (reminder.reminder_send > 1) {
                    reminder_period = reminder.time_period_value + "s";
                }

                reminder_period =
                    reminder_period + " " + reminder.reminder_send_option_value;

                reminder_send_string =
                    reminder.reminder_send +
                    " " +
                    reminder_period.toLowerCase();
            }

            return reminder_send_string;
        },
        getClientName() {
            if (!_.isEmpty(this.clientDetails)) {
                return (
                    this.clientDetails.firstname +
                    " " +
                    this.clientDetails.lastname
                );
            }

            return null;
        },
        getPatientCiLink(encodedId) {
            if (encodedId) {
                return (
                    process.env.CI_APPS + "patient/patient/view/" + encodedId
                );
            }

            return "";
        },
        openRecordDialog(reminder) {
            if (reminder) {
                Records.editRecordDetails(reminder.record_id).then(response => {
                    if (response) {
                        this.$refs.modalRecord.open({
                            ...reminder,
                            clientID: reminder.actor_id,
                            patient: {
                                id: reminder.patient_id
                            },
                            action: "edit",
                            module: this.MODULE.PATIENT,
                            record_resources: response
                        });
                    }
                    this.selectedRowId = null;
                });
            }
        }
    }
};
</script>
